/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { SelectOption, SilentSelectField } from '@coursera/cds-core';

import SettingsHelp from 'bundles/author-common/components/SettingsHelp';
import { PartnerTypeValues, getPartnerTypeLabel } from 'bundles/author-partner/constants/PartnerType';
import type { PartnerTypeValuesType } from 'bundles/author-partner/constants/PartnerType';

import _t from 'i18n!nls/author-partner';

type Props = {
  partnerType: PartnerTypeValuesType;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

const PartnerTypeEditor = ({ partnerType, onChange }: Props) => {
  return (
    <div className="rc-PartnerTypeEditor">
      <SettingsHelp>{_t(`University is the default partner type.`)}</SettingsHelp>
      <SilentSelectField
        label={_t('Partner Type')}
        onChange={onChange}
        value={partnerType}
        defaultValue={PartnerTypeValues.UNIVERSITY}
        labelPlacement="none"
        css={{
          marginTop: 'var(--cds-spacing-200)',
        }}
      >
        <SelectOption value={PartnerTypeValues.UNIVERSITY}>
          {getPartnerTypeLabel(PartnerTypeValues.UNIVERSITY)}
        </SelectOption>
        <SelectOption value={PartnerTypeValues.INDUSTRY}>
          {getPartnerTypeLabel(PartnerTypeValues.INDUSTRY)}
        </SelectOption>
        <SelectOption value={PartnerTypeValues.PRIVATE_AUTHORING}>
          {getPartnerTypeLabel(PartnerTypeValues.PRIVATE_AUTHORING)}
        </SelectOption>
      </SilentSelectField>
    </div>
  );
};

export default PartnerTypeEditor;
